import { EnumOption } from 'common/enum-value';
import AppointmentTypeDto, { mapAppointmentTypeToEnumOption } from './appointment-type-dto';
import VenueDto from './venue-dto';
import TeamDto from './team-dto';
import CityDto from './city-dto';

export enum EventStatus {
    Confirmed,
    Cancelled,
    Postponed,
    ToBeConfirmed,
    Tentative,
    New,
    Updated,
}

export enum PublishStatus {
    Draft,
    Published,
}

export const EventStatusOptions: EnumOption[] = [
    { label: 'New', value: EventStatus.New },
    { label: 'To Be Confirmed', value: EventStatus.ToBeConfirmed },
    { label: 'Updated', value: EventStatus.Updated },
    { label: 'Tentative', value: EventStatus.Tentative },
    { label: 'Confirmed', value: EventStatus.Confirmed },
    { label: 'Postponed', value: EventStatus.Postponed },
    { label: 'Cancelled', value: EventStatus.Cancelled },
];

export const getEventStatusColor = (status: EventStatus): string => {
    switch (status) {
        case EventStatus.Confirmed:
            return '#00B140';
        case EventStatus.Cancelled:
        case EventStatus.Postponed:
            return '#DF1C3C';
        case EventStatus.ToBeConfirmed:
        case EventStatus.Tentative:
            return '#F09316';
        case EventStatus.New:
        case EventStatus.Updated:
            return '#0262BC';
    }
};

let AppointmentTypeOptions: EnumOption[] = [{ value: 0, label: 'undefined' }];
export function initializeAppointmentTypeOptions(appointmentTypes: Array<AppointmentTypeDto>) {
    AppointmentTypeOptions = mapAppointmentTypeToEnumOption(appointmentTypes);
}
export { AppointmentTypeOptions };

export const PublishStatusOptions: EnumOption[] = [
    { label: 'Draft', value: PublishStatus.Draft },
    { label: 'Published', value: PublishStatus.Published },
];

type EventDto = {
    id?: number;
    localizedContents: { [key: string]: EventLocalized | undefined };
    startDate: Date | string;
    endDate: Date | string;
    imageUrl?: string;
    eventStatus: EventStatus;
    publishStatus: PublishStatus;
    colorId?: number;
    appointmentTypeId?: number;
    appointmentType?: AppointmentTypeDto;
    venueId?: number;
    venue?: VenueDto;
    customVenueName?: string;
    customVenueUrl?: string;
    modifiedTimestamp: string;
    teamIds: Array<number>;
    teams?: Array<TeamDto>;
    mainCalendarId: number;
    shouldNotifySubscribers: boolean;
    allDay: boolean;
    timeZone: string;
    sharedCalendarIds: Array<number>;
    isEstimatedTime: boolean;
    estimatedTimeDescription: string;
    hostCityId?: number;
    hostCity?: CityDto;
};

export type EventLocalized = {
    name: string;
    description?: string;
};

export type EventLogDto = {
    timestampUTC: Date | string;
    userTrigram: string;
    mainCalendarId: number;
    eventId: number;
    publishStatus: string;
    operationType: string;
    changeData: string;
}

export default EventDto;
